import React, { ComponentType, useCallback } from "react";

import IWizardStep from "@app/component/wizard/types/IWizardStep";

import BaseWizard, { BaseWizardProps } from "./BaseWizard";

export interface SingleStepWizardProps<T> extends Omit<BaseWizardProps<T>, "onGetStep"> {
  step: ComponentType<IWizardStep<T>>;
}

const SingleStepWizard = <T,>({ step, ...props }: SingleStepWizardProps<T>) => {
  const handleGetStep = useCallback(() => step, [step]);

  return <BaseWizard {...props} onGetStep={handleGetStep} />;
};

export default SingleStepWizard;
